import { useTranslation } from 'react-i18next';

import { DashboardProjectSelector } from '@/features/dashboard/components/dashboard/dashboard-project-selector';
import { ProjectSlideCardEmpty } from '@/features/dashboard/components/dashboard/project-slide-card-empty';
import { EmptyTablePlaceholderContent } from '@/shared/components/table/empty-table-placeholder';

export const EmptyProjectSlideCards = ({
  showPopoverTrigger,
}: {
  showPopoverTrigger: boolean;
}) => {
  const { t } = useTranslation('overview', {
    keyPrefix: 'OverviewPage.emptyProjectSlideCards',
  });

  return (
    <div className="relative">
      <div className="grid grid-cols-1 gap-4 md:grid-cols-2 md:gap-6">
        {[0, 1, 2, 3].map((index) => (
          <ProjectSlideCardEmpty
            key={index}
            hidePlusIcon={true}
            isBlurred={showPopoverTrigger}
          />
        ))}
      </div>
      <div className="absolute inset-0 flex items-center justify-center">
        {showPopoverTrigger && (
          <DashboardProjectSelector
            slotIndex={0}
            project={null}
            isActive={true}
            trigger={
              <EmptyTablePlaceholderContent
                title={t('title')}
                description={t('description')}
                action={() => {}}
                centered
              />
            }
          />
        )}
      </div>
    </div>
  );
};
